import { useState, useEffect, useRef } from "react";
import { ErrorCard, LoadingCard, MainContainer } from "../../components";
import { Button, Input, Card, CardBody } from "@heroui/react";
import { usePost, useFetchWithBody } from "../../api/reactQueryCustomHooks";
import { apiRoute, linksUrl } from "../../constants/enum";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resetDetail, setDetailParams } from "../../state/shadeSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";

const CreateShadeMaster = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { detailParams, isNewEntry } = useSelector((state) => state.shade);
    const [submitBtnId, setSubmitBtnId] = useState("")
    const submitLockRef = useRef(false);

    const [formData, setFormData] = useState({
        Sh_Code: "",
        Sh_Name: "",
        Sh_Group: "",
        Sh_Ord: "",
    });

    const { data: shadeDetails = [], isPending: isLoading, mutate: filterDetail } = usePost({
        url: apiRoute.shade.getshadeforupdate,
        queryKey: "fetchShadeById",
    });

    useEffect(() => {
        if (detailParams && Object.keys(detailParams).length > 0) {

            filterDetail({
                data: {
                    Sh_Code: detailParams.Sh_Code
                }
            })
        }
    }, [detailParams]);

    useEffect(() => {
        if (!isNewEntry && shadeDetails && Object.keys(shadeDetails).length > 0) {
            setFormData({
                Sh_Code: shadeDetails.Sh_Code || "",
                Sh_Name: shadeDetails.Sh_Name || "",
                Sh_Group: shadeDetails.Sh_Group || "",
                Sh_Ord: shadeDetails.Sh_Ord || "",
            });
            console.log(shadeDetails.Sh_Code, isNewEntry, formData)

        }
    }, [shadeDetails]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const { mutate: addUpdateShade, isPending, isError } = usePost({
        queryKey: "shades",
        url: apiRoute.shade.addupdateShade,
        successMessage: "Shade saved successfully!",
        onSuccessTasks: () => {

            submitLockRef.current = false;
            if (submitBtnId == 'btnSaveNew') {
                dispatch(resetDetail());
                setFormData({
                    Sh_Code: "",
                    Sh_Name: "",
                    Sh_Group: "",
                    Sh_Ord: "",
                })
            }
            else
                navigate(linksUrl.diamondParamater.shade.shadeMaster);
        },
    });

    const onSuccessChkDupCode = (data) => {
        let isDuplicate = 0
        if (!submitLockRef.current) return; // 
        if (isNewEntry && data && data.length > 0) {

            if (data[0].count > 0) {
                if (!toast.isActive("toast_chkshdid")) {
                    toast.error(`Duplicate Shade Code Found`, {
                        "position": "top-center",
                        "className": "toast-error",
                        toastId: "toast_chkshdid"
                    })
                }
                isDuplicate = 1
                setFormData({ ...formData, Sh_Code: "" })
                submitLockRef.current = false;
            }
        }
        if (isDuplicate === 0) {
            addUpdateShade({
                data: {
                    ...formData,
                    UID: user.username,
                    pRecStatus: 2,
                }
            });

        }
    }
    const { mutate: funChkDuplicateShCode } = usePost({
        queryKey: "checkShadeCode",
        url: apiRoute.shade.checkShadeCode,
        onSuccessTasks: onSuccessChkDupCode
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnId(e.nativeEvent.submitter.id)
        if (!formData.Sh_Code.trim() || !formData.Sh_Name.trim()) {
            toast.warn("Sh_Code and Sh_Name are required.");
            return;
        }
        if (submitLockRef.current) return;
        submitLockRef.current = true;
        if (isNewEntry) {
            funChkDuplicateShCode({
                data: {
                    Sh_Code: formData.Sh_Code
                }
            })
        }
        if (!isNewEntry) {
            addUpdateShade({
                data: {
                    ...formData,
                    UID: user.username,
                    pRecStatus: 1,
                }
            });
        }

    };
    const { data: ordData = [] } = useFetchWithBody({
        url: apiRoute.shade.getNextShOrd,
        queryKey: "getNextShOrd",
    });


    useEffect(() => {
        if (isNewEntry) {
            setFormData((prev) => ({
                ...prev,
                Sh_Ord: ordData.nextShOrd,
            }));
        }
    }, [isNewEntry, ordData]);

    if (isLoading || isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;
    return (
        <MainContainer
            pageName="Shade Entry"
            breadcrumbs={["Diamond Parameter", "Shade Master"]}
            prevPage={{ show: true, onClick: () => navigate(linksUrl.diamondParamater.shade.shadeMaster) }}
        >
            <Card className="p-6">
                <CardBody>

                    <form onSubmit={handleSubmit}>
                        <div className="grid gap-4">
                            <Input label="Shade Code" maxLength={10} size="sm" readOnly={isNewEntry ? false : true} name="Sh_Code" value={formData.Sh_Code} onChange={handleChange} required />
                            <h2 className="text-red-300 " style={{ fontSize: "0.7rem" }}>Shade code cannot be longer than 10 characters</h2>
                            <Input label="Shade Name" size="sm" name="Sh_Name" value={formData.Sh_Name} onChange={handleChange} required />
                            <Input label="Shade Group" size="sm" name="Sh_Group" value={formData.Sh_Group} onChange={handleChange} />
                            <Input label="Shade Order" size="sm" name="Sh_Ord" type="number" value={formData.Sh_Ord} onChange={handleChange} />
                            <div className="flex gap-4 justify-center" >
                                <Button type="submit" size="sm" id="btnSave" color="primary" isLoading={isPending}
                                 className="uppercase font-semibold"
                                >
                                    {isNewEntry ? "Save" : "Update"}
                                </Button>
                                <Button
                                    id="btnSaveNew"
                                    color="success"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    className="text-white uppercase font-semibold"
                                    startContent={<FontAwesomeIcon className=" text-md text-white" icon={faFile} />}
                                >
                                    Save & New
                                </Button>
                            </div>
                        </div>
                    </form>

                </CardBody>
            </Card>
        </MainContainer>
    );
}
export default CreateShadeMaster